import { ExcelDownloadBtn } from "components/Buttons/ExcelDownloadBtn";
import { ListDefault } from "components/ListDefault/ListDefault";
import { Info, List, Wrapper } from "template/ListTemplate.style";
import assetPayColumn from "../assetPayColumn.json";
import PageHandler from "components/PageHandler/PageHandler";
import { useToastCustom } from "hooks/useToastCustom";
import { HTTP_METHOD, POST_FIND_WALLET_MOVE } from "constants/pathConstant";
import { useMutationCustom } from "hooks/useMutationCustom";
import { ASSET_PAY_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";
import { useExcelDownload } from "hooks/excelDownload/useExcelDownload";
import { xlsxDateFormat } from "components/xlsxDateFormat";
import AssetPayDetailList from "./AssetPayDetailList";
import EmptyScreen from "components/EmptyScreen/EmptyScreen";

// 페이 자산내역 :: 페이 자산내역 리스트 (http://localhost:3000/super/asset/pay)
const AssetPayDetail = ({
  setPage,
  setSize,
  assetPayList,
  searchData,
  isSearch,
}) => {
  const toast = useToastCustom();
  const excelDownload = useExcelDownload();

  const { mutate } = useMutationCustom(POST_FIND_WALLET_MOVE, HTTP_METHOD.POST);

  const handleExcelDownload = () => {
    if (!isSearch || !assetPayList.list[0]?.cnt) {
      toast("다운로드할 데이터가 없습니다", "error");
      return;
    }

    const data = {
      ...searchData,
      pageSize: assetPayList.list[0]?.cnt,
      currentPage: 1,
    };

    mutate(data, {
      onSuccess: (response) => {
        const updatedResponse = xlsxDateFormat(response.list);

        const excelData = {
          data: updatedResponse,
          headers: ASSET_PAY_XLSX_DOWNLOAD.header,
          fileName: ASSET_PAY_XLSX_DOWNLOAD.filename,
        };

        excelDownload(excelData);
      },

      onError: () => {
        toast("전체 데이터 조회 실패", "error");
      },
    });
  };

  return (
    <Wrapper>
      <List.TitleContainer>
        <List.Text>페이 자산내역</List.Text>
        <List.BtnContainer>
          {/* 페이지 핸들러 */}
          <PageHandler setPage={setPage} setPageSize={setSize} />
          {/* 엑셀 다운로드 버튼 */}
          <ExcelDownloadBtn onClick={handleExcelDownload} />
        </List.BtnContainer>
      </List.TitleContainer>

      <List.Container>
        {!isSearch && <ListDefault text={"페이 자산내역을"} />}
        {isSearch && !assetPayList.list.length && <EmptyScreen />}
        {isSearch && !!assetPayList.list.length && (
          <>
            <List.Content>
              {assetPayColumn.data.map((v, idx) => (
                <List.Row $ratio={v.ratio} key={idx}>
                  {v.title}
                </List.Row>
              ))}
            </List.Content>
            <Info.Wrapper>
              {assetPayList.list.map((v, idx) => (
                <AssetPayDetailList key={idx} data={v} />
              ))}
            </Info.Wrapper>
          </>
        )}
      </List.Container>
    </Wrapper>
  );
};

export default AssetPayDetail;
